import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from 'components/Loadable';
import DefaultRouteErrorBoundary from 'components/error-boundary/DefaultRouteErrorBoundary';
import NavigationScroll from './NavigationScroll';

const AuthSSO = Loadable(lazy(() => import('pages/authentication/AuthSSO')));
const AuthLogin = Loadable(lazy(() => import('pages/authentication/LoginPageNew')));
const Verification = Loadable(lazy(() => import('components/verification/index')));
const ForgotPassword = Loadable(lazy(() => import('components/forgot-password/ForgotPasswordNew')));
const AuthEmailAction = Loadable(lazy(() => import('routes/AuthGuard')));

const LoginRoutes = {
	path: '/',
	element: <NavigationScroll />,
	errorElement: <DefaultRouteErrorBoundary />,
	children: [
		{
			index: true,
			element: <AuthLogin />,
		},
		{
			path: 'login',
			element: <Navigate to="/" replace />,
		},
		{
			path: 'forgot-password',
			element: <ForgotPassword />,
		},
		{
			path: 'user-registration',
			element: <Verification />,
		},
		{
			path: 'email-action',
			element: <AuthEmailAction />,
		},
		{
			path: 'login-sso',
			element: <AuthSSO />,
		},
	],
};

export default LoginRoutes;
